module.exports = __webpack_public_path__ + "media/images/spree/frontend/icons/arrow/dark/long-up-2ec5e85071db8c1b36988d775ee7e12a.png";